import React, { useEffect, useState } from 'react';
import { useClientPortal } from '../../../context/ClientPortalContext';
import { PortalProfileService } from '../../../services/portal/portalProfileService';

const ProfileExperience = () => {
    const { clientId } = useClientPortal();
    const [experience, setExperience] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (clientId) {
            loadExperience();
        }
    }, [clientId]);

    const loadExperience = async () => {
        setLoading(true);
        const { data } = await PortalProfileService.listExperience(clientId);
        setExperience(data || []);
        setLoading(false);
    };

    if (loading) return <div className="p-6 text-center text-slate-500">Loading experience details...</div>;

    return (
        <div className="space-y-6">
            <section className="bg-white border border-slate-200 rounded-2xl p-6">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold text-slate-900">Work Experience</h3>
                </div>

                {experience.length === 0 ? (
                    <p className="text-sm text-slate-500">No experience records found.</p>
                ) : (
                    <div className="space-y-4">
                        {experience.map((exp, index) => (
                            <div key={index} className="p-4 border border-slate-100 rounded-lg bg-slate-50">
                                <h4 className="font-medium text-slate-900">{exp.job_title}</h4>
                                <p className="text-sm text-slate-600">{exp.employer}</p>
                                <p className="text-xs text-slate-500 mt-1">
                                    {exp.start_date} - {exp.end_date || 'Present'}
                                </p>
                                {exp.description && <p className="text-sm text-slate-500 mt-2">{exp.description}</p>}
                            </div>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default ProfileExperience;
